import { destoryItem, sample } from "../utils.js";

/*
 * Remove button that called the function
 */
function selfDestruct(e) {
  destoryItem(e.target);
}

/*
 * Remove a random button from a set
 */
function randomDestruct({ buttons }) {
  destoryItem(sample(buttons));
}

export { selfDestruct, randomDestruct }
